import style from "./avatar.module.scss";

export interface AvatarProps {
	img?: string;
	placeholder?: string;
	className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ img, placeholder, className = "" }) => {
	return (
		<div className={`${style.avatarContainer} ${className} ${!img? style.placeholder: ''}`}>
			{img? <img style={{ width: '100%', height: '100%'}} src={img} /> : <span className={style.placeholderSpan}> {placeholder}</span>}
		</div>
	);
};
export default Avatar;
